import { Injectable } from "@angular/core";
import { Notification, NotificationDisplay } from "@dtm-frontend/shared/notifications";

@Injectable({
    providedIn: "root",
})
export abstract class BaseNotificationEventsService {
    public abstract getEventsList(notificationsToFormat: Notification[]): NotificationDisplay[];
}
